import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { BUSINESS } from "../data/site";
import { getReviews } from "../lib/api";

export default function ReviewCarousel() {
  const [reviews, setReviews] = useState([]);
  const ref = useRef(null);
  useEffect(() => {
    getReviews().then(setReviews).catch(() => setReviews([]));
  }, []);
  const scroll = (dir) => {
    ref.current?.scrollBy({ left: dir * 340, behavior: "smooth" });
  };
  return (
    <section className="py-16 sm:py-20 bg-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <div className="flex gap-1 mb-2" aria-label="5 star rating">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-sky-500 text-sky-500" />
              ))}
            </div>
            <h2 className="font-heading font-bold text-2xl sm:text-3xl text-slate-900">5-Star Rated on Google</h2>
          </div>
          <div className="hidden sm:flex gap-2">
            <button onClick={() => scroll(-1)} aria-label="Previous reviews" data-testid="reviews-prev" className="p-2.5 rounded-full border border-slate-300 text-slate-700 hover:border-sky-600 hover:text-sky-700 transition-colors">
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button onClick={() => scroll(1)} aria-label="Next reviews" data-testid="reviews-next" className="p-2.5 rounded-full border border-slate-300 text-slate-700 hover:border-sky-600 hover:text-sky-700 transition-colors">
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>
        <div ref={ref} className="flex gap-5 overflow-x-auto snap-x snap-mandatory no-scrollbar pb-2" data-testid="reviews-carousel">
          {reviews.map((r, i) => (
            <figure key={r.id || i} className="snap-start shrink-0 w-[320px] sm:w-[380px] bg-slate-50 border border-slate-200 rounded-xl p-6 flex flex-col">
              <div className="flex gap-0.5 mb-3" aria-hidden="true">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-sky-500 text-sky-500" />
                ))}
              </div>
              <blockquote className="text-slate-700 leading-relaxed text-[15px] flex-1">"{r.text}"</blockquote>
              <figcaption className="mt-4 pt-4 border-t border-slate-200">
                <span className="font-heading font-semibold text-slate-900">{r.name}</span>
                {r.location && <span className="text-sm text-slate-500"> · {r.location}</span>}
              </figcaption>
            </figure>
          ))}
        </div>
        <a
          href={BUSINESS.googleReviews}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 mt-6 text-sm font-heading font-semibold text-sky-700 hover:text-sky-800 underline underline-offset-4"
          data-testid="read-google-reviews"
        >
          Read Our Google Reviews
        </a>
      </div>
    </section>
  );
}
